import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { IntegrationTestPage } from '../components/features/spec-requirements/IntegrationTestPage.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件の総合テストのページ。列が多く事前条件が長いので、要件定義の 1 画面から切り出す
 * @graph-connects IntegrationTestPage [calls] 総合テストの表と編集
 */
export const Route = createFileRoute('/projects/spec/$pjKey/integration-test')({
  component: IntegrationTestRoutePage,
});

/** @graph-connects IntegrationTestPage [calls] 総合テストの表と編集 */
function IntegrationTestRoutePage() {
  const { pjKey } = Route.useParams();
  return (
    <ProtectedRoute pageKey="specRequirements">
      <IntegrationTestPage pjKey={pjKey} />
    </ProtectedRoute>
  );
}
